import drEasyApi from "./Customapi";

export const getUserReport = async (userID) => {
  try {
    const response = await drEasyApi.get(`/api/Reports/GetUserReport`, {
      params: {
        userID: userID,
      },
     
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching user report:", error);
    
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(
        error.response.data.message || 
        `Failed to fetch user report: ${error.response.status}`
      );
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error("No response from server. Please check your connection.");
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error("Failed to fetch user report");
    }
  }
};